import React from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Loading from './Loading';

const useStyles = makeStyles((theme) => ({
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '25%',
      borderRadius: '7.5px',
   },
}));
const LoadingPopup = () => {
   const classes = useStyles();
   return (
      <Paper className={classes.paper}>
         <Loading />
      </Paper>
   );
};

export default LoadingPopup;
